type LocalStorageValueMap = {
  fastr_failed_attempts: string;
  fastr_locked_until: string;
  fastr_practiceId: string;
  fastr_fastrId: string;
  fastr_fastrHash: string;
};

type SessionStorageValueMap = {
  fastr_token: string;
  fastr_token_createdAt: number;
  fastr_token_expiresIn: number;
  fastr_pin: string;
  "appState.theme": string;
  "appState.breakpoint": string;
};

abstract class StorageService<TValueMap> {
  protected static storage: Storage;

  getStorage() {
    return (this.constructor as typeof StorageService).storage;
  }

  get<K extends keyof TValueMap>(key: K): TValueMap[K] | null {
    const raw = this.getStorage().getItem(key as string);
    return raw == null ? null : JSON.parse(raw);
  }

  set<K extends keyof TValueMap>(key: K, value: TValueMap[K]): void {
    if (value == null) {
      this.remove(key);
      return;
    }

    this.getStorage().setItem(key as string, JSON.stringify(value));
  }

  remove<K extends keyof TValueMap>(key: K): void {
    this.getStorage().removeItem(key as string);
  }
}

class LocalStorageService extends StorageService<LocalStorageValueMap> {
  protected static storage = localStorage;
}

class SessionStorageService extends StorageService<SessionStorageValueMap> {
  protected static storage = sessionStorage;
}

export const localStorageService = new LocalStorageService();
export const sessionStorageService = new SessionStorageService();
